import { Component, OnInit } from "@angular/core";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { AdminDashboardService } from "../services/admin-dashboard.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
  selector: "app-events-log",
  templateUrl: "./events-log.component.html",
  styleUrls: ["./events-log.component.scss"],
})
export class EventsLogComponent implements OnInit {
  public filter: string;
  public events;
  public rows;
  public columns;
  public dataLoaded: boolean;
  public eventList;
  public sectionList;

  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private admin: AdminDashboardService,
    public themeService: ThemeService
  ) {
    this.filter = "EVENT(event);EVENT(section);EVENT(created_at)";
  }

  async ngOnInit() {
    this.refresh();
    this.eventList = await this.admin.retrieveEventParams("event");
    this.sectionList = await this.admin.retrieveEventParams("section");
  }

  public async refresh() {
    this.dataLoaded = false;
    this.columns = [];
    this.events = await this.admin.retrieveEvents(undefined, this.filter);
    if (this.events && this.events.length) {
      this.dataLoaded = true;
      let event = this.events[0];
      let cols = this.filter.match(/EVENT\([a-z_]+/g);
      for (let column of cols) {
        let key = column.replace(/EVENT\(/g, "");
        this.columns.push({
          field: key,
          sortable: true,
          filter: true,
          editable: true,
        });
      }
      this.rows = [];
      this.events.map((ev) => {
        let obj = {};
        for (let i in ev) {
          if (this.columns && this.columns.length) {
            obj[this.columns[i].field] = ev[i];
          }
        }
        this.rows.push(obj);
      });
    } else {
      this.dataLoaded = false;
    }
  }
}
